import { Dialog, DialogContent, DialogTitle, Grid, Paper } from "@mui/material";
import React, { useEffect, useState } from "react";
import Draggable from "react-draggable";
import MDBox from "../../../Components/MDBox";
import MDButton from "../../../Components/MDButton";
import MDDivider from "../../../Components/MDDivider";
import MDInput from "../../../Components/MDInput";
import MDTypography from "../../../Components/MDTypography";
import { v4 as uuid } from "uuid";
import { SenfModel } from "../../../Api/Models/SenfModel";
import { ErrorToaast } from "../../../utils/toast/Toast";
function PaperComponent(props: any) {
  return (
    <Draggable handle="#draggable-dialog-title" cancel={'[class*="MuiDialogContent-root"]'}>
      <Paper {...props} />
    </Draggable>
  );
}
export default function SearchSend(props: { open: boolean; setClose: any; onDone: any; handleClick: any }) {
  const [data, setData] = useState([]);
  const [search, setSearch] = useState("");
  const senfModel = new SenfModel();
  const handleSearch = () => {
    if (search === "") return;
    senfModel
      .GetSearch(search)
      .then((result) => {
        setData(result.data.data);
      })
      .catch((err) => {
        ErrorToaast("مشکل در برقراری ارتباط");
      });
  };

  return (
    <Dialog open={props.open} onClose={props.setClose} PaperComponent={PaperComponent} aria-labelledby="draggable-dialog-title">
      <DialogTitle style={{ cursor: "move" }} id="draggable-dialog-title">
        <MDTypography variant="h">جستجوی اصناف</MDTypography>
      </DialogTitle>
      <DialogContent>
        <MDBox>
          <Grid container py={1} gap="0 10px">
            <Grid item xs={2} textAlign="center" alignSelf={"center"}>
              <MDTypography fontSize={"14px"} fontWeight="bold">
                نام صنف
              </MDTypography>
            </Grid>
            <Grid item xs={3}>
              <MDInput size="small" onChange={(e: any) => setSearch(e.target.value)} value={search} fullWidth />
            </Grid>
            <Grid item xs={2}>
              <MDButton variant="outlined" color="secondary" onClick={handleSearch}>
                جستجو
              </MDButton>
            </Grid>
          </Grid>
          <MDDivider />
        </MDBox>
        <MDBox minHeight="40vh" maxHeight="40vh" sx={{ overflow: "auto" }} bgColor="#adaabb" mt={1} border="2px #5b5b5b solid">
          <MDBox bgColor="#a665c224" px={1}>
            <Grid container columns={4} textAlign="center">
              <Grid item xs={1}>
                <MDTypography fontSize={"14px"} borderRight={"1px #000 solid"}>
                  نام صنف
                </MDTypography>
              </Grid>
              <Grid item xs={1}>
                <MDTypography fontSize={"14px"} borderRight={"1px #000 solid"}>
                  زیر شاخه
                </MDTypography>
              </Grid>

              <Grid item xs={1}>
                <MDTypography fontSize={"14px"} borderRight={"1px #000 solid"}>
                  سال مالی
                </MDTypography>
              </Grid>

              <Grid item xs={1}>
                <MDTypography fontSize={"14px"}>ضریب</MDTypography>
              </Grid>
            </Grid>
          </MDBox>
          {data.length > 0 ? (
            data.map((data: any, index: number) => {
              return (
                <MDBox
                  bgColor={index % 2 === 0 ? "#dfdfdf" : "white"}
                  px={1}
                  key={uuid()}
                  onClick={() => {
                    props.handleClick(data);
                  }}
                  sx={{ ":hover": { background: "#9185c8" }, cursor: "pointer" }}
                >
                  <Grid container columns={4} textAlign="center">
                    <Grid item xs={1} borderRight={"1px #000 solid"}>
                      <MDTypography fontSize={"14px"}>{data.asnafCategory.title ?? ""}</MDTypography>
                    </Grid>
                    <Grid item xs={1} borderRight={"1px #000 solid"}>
                      <MDTypography fontSize={"14px"}>{data.title ?? ""}</MDTypography>
                    </Grid>
                    <Grid item xs={1} borderRight={"1px #000 solid"}>
                      <MDTypography fontSize={"14px"}>{data.asnafCategory.salMali ?? ""}</MDTypography>
                    </Grid>
                    <Grid item xs={1}>
                      <MDTypography fontSize={"14px"}>{data.gheymat ?? ""}</MDTypography>
                    </Grid>
                  </Grid>
                </MDBox>
              );
            })
          ) : (
            <MDBox bgColor="white" textAlign="center">
              <MDTypography fontSize="14px" fontWeight="bold">
                جستجو نتیجه ای نداشت
              </MDTypography>
            </MDBox>
          )}
        </MDBox>
      </DialogContent>
    </Dialog>
  );
}
